<template>
  <v-app>
    <v-main 
      style="overflow: hidden;" 
      class="mx-auto"
      v-if="temposEspera.length > 0"
    >
      <div class='d-flex flex-column flex-lg-row ' >
        <div class="pa-4 d-flex flex-column justify-space-between" style="background-color: #00995d;">
          <div class="d-flex flex-column flex-md-row justify-center align-center">
            <img src="@/assets/imgs/icone-relogio.png" alt="Ícone de relógio, referenciando o tempo de espera do Pronto Atendimento" class="mx-4" style="width: 30px; height: 30px;" />
            <span class="titulo text-center">
              Tempo de espera estimado do <span class="unimed24horas">Unimed 24 horas</span>
            </span>
          </div>
          <IndicadorCardsDesktop :temposEspera="temposEspera" :ehCelular="ehCelular" @clinicaSelecionada="selecionaClinica" />
          <div></div>
        </div>
        <div class="mx-lg-1 my-1 my-lg-0 d-flex flex-column justify-center align-center descricaoAtendimentoEsu pa-4" style="background-color: #004e4c;">
          <h4 class="text-center">Agilize seu <br> atendimento</h4>
          <v-btn color="#b1d34b" class="botaoAgendaAgora my-3"
            @click="redirecionarAgendamentoESU"
          >
            <img src="@/assets/imgs/icone-check.png" alt="Ícone de 'Check' para consulta " class="icon mr-2" />
            Agende agora
          </v-btn>
          <h4>sua consulta!</h4>
        </div>
        <div class="d-flex flex-column align-center flex-md-row justify-space-between pa-4" style="background-color: #cde3bb;">
          <div class="d-flex flex-column justify-space-between mx-4" 
          :style="'max-width: ' + ((ehCelular) ? '200px' : '128px') + ';'">
            <img src="@/assets/imgs/logo-clínica.png" alt="Logo Clínica Unimed"/>
            <div class="mt-2 d-flex flex-row justify-space-between align-center">
              <h4 class="subtitulo">Horários disponíveis</h4>
              <img 
                src="@/assets/imgs/icone-seta.png" 
                alt="Ícone de seta para direita" 
                class="icon-seta ml-2" 
                :style="(ehCelular) ? 'transform: rotate(90deg);' : ''"
              />
            </div>
          </div>
          <div class="d-flex flex-column flex-md-row">
            <v-card 
              :min-width='(ehCelular) ? 200 : 100'
              v-for="(h, i) in horariosLivresESU"
              :key="i" 
              class="mx-1 my-2 mt-sm-0 d-flex flex-column rounded-lg"
            >
              <div 
                class="d-flex justify-center align-center rounded-lg"
                style="background-color: #00995d"
              >
                <span class="text-center clinica my-2">{{ h.clinica }}</span>
              </div>
              <div class="d-flex flex-column justify-center pa-2">
                <div v-for="(ho, index) in h.horarios" :key="ho" class="text-center">
                  <span class="horaDisponivel">{{ ho }}</span>
                  <v-divider v-if="index < h.horarios.length - 1"></v-divider>
                </div>
              </div>
            </v-card>
          </div>
        </div>
      </div>
    </v-main>
    <v-main v-else>
      <div style="width: 50%;" class="mx-auto mt-6">
        <v-progress-linear
          color="#035e53"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </div>
    </v-main>
  </v-app>
</template>

<script>
  import axios from 'axios'
  import IndicadorCardsDesktop from './components/IndicadorCardsDesktop.vue';

  export default {
    components: { IndicadorCardsDesktop },
    name: 'App',
    data: () => ({
      temposEspera: [],
      horariosLivresESU: [],
      clinicaSelecionada: 0,
      mediaAtendimentosPorHora: [],
      width: window.innerWidth,
    }),
    mounted() {
      
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
      })
    },
    beforeDestroy() { 
      window.removeEventListener('resize', this.onResize); 
    },
    created() {
      this.getTempoEspera();
      this.getHorariosLivresESU();

      setInterval(() => {
        this.getTempoEspera()
        this.getHorariosLivresESU()
      }, 180000); // 180000 = 3 minutos
    },
    computed: {
      ehCelular() {
        return this.width < 660;
      },
      ehNotebook() {
        return this.width < 1460;
      },

      tamanhoLimite() {
        return this.width < 1072;
      }
    },
    methods: {
      onResize() {
        this.width = window.innerWidth;
      },
      redirecionarAgendamentoESU() {
        window.open("https://agendamentos.unimedpg.com.br/esu", "_blank");
      },
      async getTempoEspera() {

        await axios({
          method: 'get',
          url: 'https://api.unimedpg.com.br/integracoes-api/temposesperapa/web',
          // url: 'http://10.100.69.207:8080/IntegracoesAPITeste/temposesperapa/web',
          headers: {
            'Authorization': 'eef84a3b4ee1cb979a211396eedb50bd'
          }
        }).then(res => {

          this.temposEspera = res.data;
          this.temposEspera.forEach((t) => t.tempoEsperaAtual = this.formataTempoEspera(t.tempoEsperaAtual));
        })
      },
      async getHorariosLivresESU() {

        await axios({
          method: 'get',
          url: 'https://api.unimedpg.com.br/integracoes-api/temposesperapa/horarios-esu',
          // url: 'http://10.100.69.207:8080/IntegracoesAPITeste/temposesperapa/horarios-esu',
          headers: {
            'Authorization': 'eef84a3b4ee1cb979a211396eedb50bd'
          }
        }).then(res => {

          this.horariosLivresESU = res.data;
        })
      },
      formataTempoEspera(tempoEsperaAtual) {

        if (tempoEsperaAtual.includes('h') && tempoEsperaAtual.includes('min')) {

          if (tempoEsperaAtual.substring(0, 1) == '0') {
            
            if (tempoEsperaAtual.includes('00min')) {

              return tempoEsperaAtual.substring(1).replace('h', ' h').replace('00min', '');
            } else {

              return tempoEsperaAtual.substring(1).replace('h', 'h ').replace('min', '');
            }
          } else {

            if (tempoEsperaAtual.includes('00min')) {

              return tempoEsperaAtual.replace('h', ' h').replace('00min', '');
            } else {

              return tempoEsperaAtual.replace('h', 'h ').replace('min', '');
            }
          }
        } else if (tempoEsperaAtual.includes('min')) {

          return tempoEsperaAtual.replace('min', ' min');
        } else {

          return tempoEsperaAtual;
        }
      },
      selecionaClinica(index) {

        this.clinicaSelecionada = index;
      }
    }
  };
</script>

<style>
  #app {
    background-color: #fff;
    overflow: hidden;
    position: relative;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }

  ::-webkit-scrollbar {
    background-color: transparent;
    width: 0;
  }

  .border {
    border-radius: 12.3px;
  }

  @font-face {
    font-family: UnimedSansRegular;
    src: url(./assets/UnimedSans/UnimedSans2020-Rg.otf);
  }

  @font-face {
    font-family: UnimedSansBold;
    src: url(./assets/UnimedSans/UnimedSans2020-Bd.otf);
  }
  
  @font-face {
    font-family: UnimedSansSemiBold;
    src: url(./assets/UnimedSans/UnimedSans2020-Sb.otf);
  }

  @font-face {
    font-family: UnimedSansSemiBoldItalic;
    src: url(./assets/UnimedSans/UnimedSans2020-SbIt.otf);
  }
  
  @font-face {
    font-family: UnimedSlabSemiBold;
    src: url(./assets/UnimedSlab/UnimedSlab2020-Sb.otf);
  }

  @font-face {
    font-family: UnimedSlabExtraBold;
    src: url(./assets/UnimedSlab/UnimedSlab2020-Xb.otf);
  }

  .titulo {
    font-family: UnimedSlabSemiBold;
    font-size: 1.4em;
    color: #ffffff;
  }

  .unimed24horas {
    font-family: UnimedSlabExtraBold;
    font-size: 1.1em;
    color: #004e4c;
  }

  .subtitulo {
    font-family: UnimedSlabSemiBold;
    font-size: 1.1em;
    color: #00995d;
  }

  .clinica {
    font-family: UnimedSansBold;
    font-size: 1.1em;
    color: white;
    text-transform: uppercase;
  }

  .tempoEspera {
    font-family: UnimedSansSemiBold;
    font-size: 16px;
    color: #004e4c;
  }

  .semTempoEspera {
    font-family: UnimedSansSemiBoldItalic;
    color: #004e4c;
    font-size: 16px;
    text-transform: uppercase
  }

  .labelIndicativoFoco {
    font-family: UnimedSansRegular;
    font-size: 0.6em;
    color: #e44b23;
  }

  .indicativoFocoIndicador {
    width: 8px;
    height: 8px;
    background-color: #e44b23;
  }

  .botaoAcaoIndicador {
    font-family: UnimedSansSemiBoldItalic;
    font-size: 1em;
    color: #035e53;
  }

  .icon {
    width: 15px;
    height: 15px;
  }

  .icon-seta {
    width: 12px;
    height: 19px;
  }

  .descricaoAtendimentoEsu {
    font-family: UnimedSansRegular;
    font-size: 1.1em;
    color: #ffffff;
  }

  .botaoAgendaAgora {
    font-family: UnimedSansBold;
    font-size: 0.9em !important;
    color: #004e4c !important;
    text-transform: capitalize !important;
  }

  .horaDisponivel {
    font-family: UnimedSansSemiBold;
    font-size: 0.9em;
    color: #004e4c;
  }
</style>
